import Table from '../../components/BPMTable/TableComponents/TableWrapper/SetupTableData'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import { BudgetReportTableCreator } from '../../tableDefinitions/Budget/BudgetReportTableCreator'

export default function BudgetReportTable(props) {
    var tableCreatorCreator = tableCreatorCreatorFactoryCreator.getTableCreatorCreatorFromIdentifier(BudgetReportTableCreator.getId(), {tcFilters: props.filters})
    tableCreatorCreator.setParentProps(props)
    const tableCreator = tableCreatorCreator.getTableCreator("Budget Report")

    return (
        <Table
            TableCreator={tableCreator}
            stickyHeader
        />
    )
}
